var map = {
	"./Black_Account_Icons-01.png": 608,
	"./Black_Account_Icons-02.png": 609,
	"./Black_Account_Icons-03.png": 610,
	"./Black_Account_Icons-04.png": 611,
	"./Black_Account_Icons-05.png": 612,
	"./Black_Account_Icons-06.png": 613,
	"./Black_Account_Icons-07.png": 614,
	"./Black_Account_Icons-08.png": 615,
	"./Black_Account_Icons-09.png": 616,
	"./Black_Account_Icons-10.png": 617,
	"./Black_Account_Icons-11.png": 618,
	"./Black_Account_Icons-12.png": 619,
	"./Black_Account_Icons-13.png": 620,
	"./Black_Account_Icons-14.png": 621,
	"./FilePresentOutlined.svg": 622,
	"./accuracyAccountsDemo_downloadMT4.jpg": 623,
	"./accuracyAccountsReal_downloadMT4.jpg": 624,
	"./alert@2x.svg": 625,
	"./apple-brands.svg": 626,
	"./arrow_up_from_box.svg": 627,
	"./bankWire.svg": 628,
	"./bdswissDemo_downloadMT4.png": 629,
	"./bdswissGlobalDemo_downloadMT4.png": 630,
	"./bdswissGlobalReal02_downloadMT4.png": 631,
	"./bdswissGlobalReal03_downloadMT4.png": 632,
	"./bdswissGlobalReal04_downloadMT4.png": 633,
	"./bdswissGlobalReal05_downloadMT4.png": 634,
	"./bdswissGlobalReal_downloadMT4.png": 635,
	"./bdswissGlobalReal_downloadMT5.png": 636,
	"./bdswissReal02_downloadMT4.png": 637,
	"./bdswissReal03_downloadMT4.png": 638,
	"./bdswissReal04_downloadMT4.png": 639,
	"./bdswissReal05_downloadMT4.png": 640,
	"./bdswissReal_downloadMT4.png": 641,
	"./bdswissReal_downloadMT5.png": 642,
	"./bdswissSCDemo_downloadMT4.png": 643,
	"./bdswissSCReal01_downloadMT4.png": 644,
	"./bdswissSCReal02_downloadMT4.png": 645,
	"./bdswissSCReal03_downloadMT4.png": 646,
	"./bdswissSCReal04_downloadMT4.png": 647,
	"./bdswissSCReal05_downloadMT4.png": 648,
	"./bdswiss_grey.png": 649,
	"./bdswiss_white.png": 650,
	"./bg-image-affiliate.png": 651,
	"./bitwallet-bdSwiss-dark.svg": 652,
	"./bitwallet-bdSwiss-light.svg": 653,
	"./bitwallet-swissMarkets-dark.svg": 654,
	"./bitwallet-swissMarkets-light.svg": 655,
	"./card.svg": 656,
	"./check_circle.png": 657,
	"./chf.png": 658,
	"./competitions.png": 659,
	"./complimentary@2x.svg": 660,
	"./control-radio-off.png": 661,
	"./control-radio-on.png": 662,
	"./crypto.svg": 663,
	"./cvv.svg": 664,
	"./deposit-card.svg": 665,
	"./diners.png": 666,
	"./dkk.png": 667,
	"./document-upload-failure-dark.png": 668,
	"./document-upload-failure-light.png": 669,
	"./document-upload-success-black.png": 670,
	"./document-upload-success-dark.png": 671,
	"./document-upload-success-light.png": 672,
	"./documents-empty-dark.png": 673,
	"./documents-empty-light.png": 674,
	"./downloadPdf-light.png": 675,
	"./downloadPdf.png": 676,
	"./dpWorldTourChampionship-dark.svg": 677,
	"./dpWorldTourChampionship-light.svg": 678,
	"./eWallet.svg": 679,
	"./eur.png": 680,
	"./exp-date.svg": 681,
	"./fees@2x.svg": 682,
	"./filterIcon.png": 683,
	"./gbp.png": 684,
	"./icon-add-account.svg": 411,
	"./icon-appstore@2x.png": 685,
	"./icon-arrow-right-dark.png": 686,
	"./icon-arrow-right-light.png": 687,
	"./icon-bank-wire.svg": 688,
	"./icon-checkbox.svg": 689,
	"./icon-close-dark.svg": 690,
	"./icon-close-light.svg": 691,
	"./icon-close.png": 692,
	"./icon-contact-callback@2x.png": 693,
	"./icon-contact-callback@2x.svg": 694,
	"./icon-contact-chat@2x.png": 412,
	"./icon-contact-chat@2x.svg": 413,
	"./icon-contact-email@2x.png": 695,
	"./icon-contact-email@2x.svg": 696,
	"./icon-contact-faqs@2x.png": 697,
	"./icon-contact-faqs@2x.svg": 698,
	"./icon-contact-oneOnOneSession@2x.png": 699,
	"./icon-contact-telegram@2x.png": 700,
	"./icon-contact-whatsapp@2x.png": 701,
	"./icon-crypto.svg": 702,
	"./icon-document.svg": 703,
	"./icon-facebook@2x.png": 704,
	"./icon-google-play@2x.png": 705,
	"./icon-notification.svg": 706,
	"./icon-profile-big.svg": 707,
	"./icon-profile.svg": 708,
	"./icon-spoa.svg": 709,
	"./icon-swapFree.svg": 710,
	"./icon-telegram@2x.png": 711,
	"./icon-twitter@2x.png": 712,
	"./icon_accounts_dashboard.svg": 713,
	"./icon_logout_dashboard.svg": 714,
	"./icon_notification_dashboard.svg": 715,
	"./icon_profilesettings_dashboard.svg": 716,
	"./icon_support_dashboard.svg": 717,
	"./icon_transaction_dashboard.svg": 718,
	"./jcb.png": 719,
	"./knet-logo.png": 414,
	"./languages.png": 720,
	"./limit-failure-dark.png": 721,
	"./limit-failure-light.png": 722,
	"./logo-accuracy.png": 723,
	"./logo-bdstrading-white.svg": 724,
	"./logo-bdstrading.svg": 725,
	"./logo-bdswiss-white.svg": 726,
	"./logo-bdswiss.png": 727,
	"./logo-bdswiss.svg": 728,
	"./logo-equityflow-black.png": 729,
	"./logo-equityflow-white.png": 730,
	"./logo-facebook.png": 731,
	"./logo-google.png": 732,
	"./logo-google.svg": 733,
	"./logo-lydian-black.png": 734,
	"./logo-lydian-black.svg": 735,
	"./logo-lydian-white.svg": 736,
	"./logo-regalx-white.png": 737,
	"./logo-regalx.png": 738,
	"./logo-skyground-black.svg": 739,
	"./logo-skyground-white.svg": 740,
	"./logo-swissmarkets-white.svg": 741,
	"./logo-swissmarkets.png": 742,
	"./logo-swissmarkets.svg": 743,
	"./logo-tauromarkets-black.png": 744,
	"./logo-tauromarkets-white.png": 745,
	"./logo-tauromarkets-white2.png": 746,
	"./logo-tauromarkets-white2.svg": 747,
	"./logo-valutamarkets.png": 748,
	"./maestro.png": 749,
	"./mastercard.png": 750,
	"./mastercard_logo_icon.svg": 751,
	"./mercedesCup-dark.svg": 752,
	"./mercedesCup-light.svg": 753,
	"./nationalIdBR.png": 754,
	"./nationalIdES.jpg": 755,
	"./nationalIdIT.jpg": 756,
	"./nationalIdZA.png": 757,
	"./no-trades-dark.png": 758,
	"./no-trades-light.png": 759,
	"./no-trading-signals-dark.png": 760,
	"./nok.png": 761,
	"./notifications-empty-dark.png": 762,
	"./notifications-empty-light.png": 763,
	"./onlineBanking.svg": 764,
	"./onlineDeposit.svg": 765,
	"./page-not-found-dark.svg": 415,
	"./page-not-found-light.svg": 416,
	"./payment-failure-dark.png": 766,
	"./payment-failure-light.png": 767,
	"./payment-pending-dark.png": 768,
	"./payment-pending-light.png": 769,
	"./payment-success-dark.png": 770,
	"./payment-success-light.png": 771,
	"./payments-history-empty-dark.png": 772,
	"./payments-history-empty-light.png": 773,
	"./phone_verification.png": 774,
	"./place1-leadership.png": 775,
	"./place2-leadership.png": 776,
	"./place3-leadership.png": 777,
	"./pln.png": 778,
	"./pof-bankStatement.png": 779,
	"./pof-bankStatementPOF.png": 780,
	"./pof-card-back.png": 781,
	"./pof-card.png": 782,
	"./pof-cardStatement.png": 783,
	"./pof-other.png": 784,
	"./pof-proofOfResidence.png": 785,
	"./pof-swiftCopyPaymentAdvice.png": 786,
	"./pof-virtualCard.png": 787,
	"./poi-document.png": 788,
	"./poi-drivingLicense-back.png": 789,
	"./poi-drivingLicense.png": 790,
	"./poi-id-back.png": 791,
	"./poi-id.png": 792,
	"./poi-passport.png": 793,
	"./por-bankStatementPOR.png": 794,
	"./por-document.png": 795,
	"./por-proofOfResidence.png": 796,
	"./por-utilityBill.png": 797,
	"./priority@2x.svg": 798,
	"./referAndEarn.png": 799,
	"./regalxDemo_downloadMT4.png": 800,
	"./regalxReal01_downloadMT4.png": 801,
	"./regalxReal02_downloadMT4.png": 802,
	"./regalxReal03_downloadMT4.png": 803,
	"./regalxReal04_downloadMT4.png": 804,
	"./regalxReal05_downloadMT4.png": 805,
	"./register-referral-light.png": 806,
	"./sek.png": 807,
	"./sign-up.png": 808,
	"./spaceship.png": 809,
	"./spreads@2x.svg": 810,
	"./support@2x.svg": 811,
	"./swissmarketsDemo_downloadMT4.png": 812,
	"./swissmarketsReal02_downloadMT4.png": 813,
	"./swissmarketsReal_downloadMT4.png": 814,
	"./tauroDemo01DownloadMT4.jpg": 815,
	"./tauroReal01DownloadMT4.jpg": 816,
	"./technicalIndicator-ebook.png": 817,
	"./technicalIndicatorItem.svg": 818,
	"./telegram-dark.png": 819,
	"./telegram.png": 820,
	"./trading-alerts-tradingAlerts-dark.png": 821,
	"./trading-alerts-tradingAlerts-light.png": 822,
	"./tradingPsychology-ebook.png": 823,
	"./tradingPsychologyItem.svg": 824,
	"./transfer-external.svg": 825,
	"./transfer-internal.svg": 826,
	"./transfer-spoa.svg": 827,
	"./upload-bankStatement-error.png": 828,
	"./upload-bankStatement-success.png": 829,
	"./upload-bankStatement.png": 830,
	"./upload-document-dark.png": 831,
	"./upload-document-light.png": 832,
	"./upload-generic-error.png": 833,
	"./upload-generic-success.png": 834,
	"./upload-generic.png": 835,
	"./upload-pof-back-card-error.png": 836,
	"./upload-pof-back-card-success.png": 837,
	"./upload-pof-back-card.png": 838,
	"./upload-pof-front-card-error.png": 839,
	"./upload-pof-front-card-success.png": 840,
	"./upload-pof-front-card.png": 841,
	"./upload-poi-back-drivingLicense-error.png": 842,
	"./upload-poi-back-drivingLicense-success.png": 843,
	"./upload-poi-back-drivingLicense.png": 844,
	"./upload-poi-back-error.png": 845,
	"./upload-poi-back-success.png": 846,
	"./upload-poi-back.png": 847,
	"./upload-poi-front-drivingLicense-error.png": 848,
	"./upload-poi-front-drivingLicense-success.png": 849,
	"./upload-poi-front-drivingLicense.png": 850,
	"./upload-poi-front-error.png": 851,
	"./upload-poi-front-success.png": 852,
	"./upload-poi-front.png": 853,
	"./upload-por-front-error.png": 854,
	"./upload-por-front-proofOfResidence-error.png": 855,
	"./upload-por-front-proofOfResidence-success.png": 856,
	"./upload-por-front-proofOfResidence.png": 857,
	"./upload-por-front-success.png": 858,
	"./upload-por-front-utilityBill-error.png": 859,
	"./upload-por-front-utilityBill-success.png": 860,
	"./upload-por-front-utilityBill.png": 861,
	"./upload-por-front.png": 862,
	"./usd.png": 863,
	"./visa.png": 864,
	"./visa_logo_icon.svg": 865,
	"./vps-enter-credentials.png": 866,
	"./vps-remote-desktop-windows.png": 867,
	"./vps-remote-desktop.png": 868,
	"./waiting-list-skip-dark.png": 869,
	"./waiting-list-skip.png": 870,
	"./windows-brands.svg": 871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1195;